"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ListboxContext: function() {
        return ListboxContext;
    },
    ListboxProvider: function() {
        return ListboxProvider;
    }
});
const _reactcontextselector = require("@fluentui/react-context-selector");
const ListboxContext = (0, _reactcontextselector.createContext)({
    activeOption: undefined,
    focusVisible: false,
    multiselect: false,
    registerOption () {
        return ()=>undefined;
    },
    selectedOptions: [],
    selectOption () {
    // noop
    },
    setActiveOption () {
    // noop
    }
});
const ListboxProvider = ListboxContext.Provider;
